export default __webpack_public_path__ + "static/media/img (3).7d553e39.jpg";